export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    'Manutenção Predial',
    'Jardinagem e Paisagismo',
    'Segurança e Portaria',
    'Limpeza Especializada',
    'Administração Predial',
    'Reformas e Melhorias'
  ];

  const quickLinks = [
    { name: 'Início', href: '#inicio' },
    { name: 'Serviços', href: '#servicos' },
    { name: 'Sobre Nós', href: '#sobre' },
    { name: 'Contato', href: '#contato' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '5551995670049';
    const message = encodeURIComponent('Olá! Gostaria de solicitar um orçamento para serviços condominiais.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/b69cde7a13f4ad572f616ac3fb1754b6/e1e201c965bd79027b63ff9b024ed493.png" 
              alt="PRIMECONDOMINIALSOLUCOES Logo" 
              className="h-16 w-auto mb-6 cursor-pointer brightness-0 invert"
              onClick={() => scrollToSection('inicio')}
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Especialistas em serviços para prédios e condomínios há mais de 15 anos. 
              Agilidade e comprometimento em cada projeto.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <button onClick={handleWhatsAppClick} className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Nossos Serviços</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#servicos" onClick={(e) => { e.preventDefault(); scrollToSection('servicos'); }} className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }} 
                    className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Contato</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-orange-400 mr-3 mt-1"></i>
                <div>
                  <p className="text-gray-300">Rua Tiradentes, 764</p>
                  <p className="text-gray-300">Canoas - RS</p>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-orange-400 mr-3"></i>
                <p className="text-gray-300">(51) 99567-0049</p>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-orange-400 mr-3"></i>
                <p className="text-gray-300">primecondominialsolucoes@gmail.com</p>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-orange-400 mr-3"></i>
                <p className="text-gray-300">Seg a Sex: 8h às 18h</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} PRIME SOLUÇÕES. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">
                Termos de Uso
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
